module.exports = __webpack_public_path__ + "fonts/511da341e68f0768e9044fb7c3311a4b.svg";